/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useState, createContext } from 'react';
import React from 'react';
import { AppConfiguration } from '../lib/type';
import { Scenario } from '../data/constants';

import Intro from './Intro/Intro';
import Questions from './Questions/index';
import Results from './Results/Results';

export interface CODBGameProps {
  /**
   * All the configuration for the map
   */
  configuration: AppConfiguration;
}
// Defining a type for selectedOption context element

export const layoutContext = createContext({
  currentScenario: '',
  setCurrentScenario: (type: Scenario) => {},
  selectedItems: {},
  setSelectedItems: (items: object) => {},
  selectedOption: {
    optionId: '',
    nextStep: '',
    correctAnswer: 0,
  },
  setSelectedOption: (items: {
    optionId: string;
    nextStep: string;
    correctAnswer: number;
  }) => {},
  doublechancedisableclassname: '',
  setDoublechancedisableclassname: (doublechancedisableclassname: string) => {},
  watsonButton: false,
  setWatsonButton: (watson: boolean) => {},
  showPercentageButton: false,
  setShowPercentageButton: (percentage: boolean) => {},
  disabledOptions: 0,
  setDisabledOptions: (disabled: number) => {},
  doubleChance: false,
  setDoubleChance: (chance: boolean) => {},
  refreshclicked: false,
  setRefreshclicked: (chance: boolean) => {},
});

const CODBGame = ({ configuration }: CODBGameProps): ReactElement => {
  const [currentScenario, setCurrentScenario] = useState(Scenario.introduction);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedOption, setSelectedOption] = useState({
    optionId: '',
    nextStep: '',
    correctAnswer: 0,
  });
  const [doublechancedisableclassname, setDoublechancedisableclassname] =
    useState('appearedclass');
  const [watsonButton, setWatsonButton] = useState(false);
  const [showPercentageButton, setShowPercentageButton] = useState(false);
  const [doubleChance, setDoubleChance] = useState(false);
  const [disabledOptions, setDisabledOptions] = useState<number>(0);
  const [refreshclicked, setRefreshclicked] = useState(false);

  const handleScenario = () => {
    switch (currentScenario) {
      case 'introduction':
        return <Intro contents={configuration.introduction} />;
      case 'questions':
        return <Questions contents={configuration.questions} />;
      case 'results':
        return <Results contents={configuration.results} />;
      default:
        return <Intro contents={configuration.introduction} />;
    }
  };

  return (
    <layoutContext.Provider
      value={{
        currentScenario,
        setCurrentScenario,
        selectedItems,
        setSelectedItems,
        selectedOption,
        setSelectedOption,
        doublechancedisableclassname,
        setDoublechancedisableclassname,
        watsonButton,
        setWatsonButton,
        showPercentageButton,
        setShowPercentageButton,
        disabledOptions,
        setDisabledOptions,
        doubleChance,
        setDoubleChance,
        refreshclicked,
        setRefreshclicked,
      }}
    >
      <div className="codb-game">{handleScenario()}</div>
    </layoutContext.Provider>
  );
};

export default CODBGame;
